// extracted by mini-css-extract-plugin
module.exports = {"title":"LotTitle_title__XEggG","canceledLabel":"LotTitle_canceledLabel__dYHst"};